import { useState, type FormEvent } from 'react';
import { upperMantendoCursor } from '../../components/inputs/UpperInput';
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_NAME, APP_VERSION } from '@fiodecobre/shared';
import { useAuth } from '../../lib/auth';
import { lerMotivoLogin } from '../../lib/api';
import { useManifesto, MANIFESTO_SISTEMA } from '../../lib/useManifesto';
import { useVersao, detalheVersao } from '../../components/RodapeVersao';
import { ehFalhaDeRede, estaSemConexao, useSemConexao } from '../../lib/emergencia';

// Sem servidor nao ha como conferir senha. Decisao do Ruan (24/10/2026): aparelho sem ninguem
// logado NAO entra no modo emergencia.
const MSG_SEM_SERVIDOR = 'O sistema esta fora do ar. O modo emergencia so funciona no computador que ja estava logado — use outro computador da loja.';

export function Login() {
  const { login: doLogin } = useAuth();
  // Instalar o app a partir do login instala o app do SISTEMA (start_url /), nao a vitrine.
  useManifesto(MANIFESTO_SISTEMA);
  // Versao REAL do deploy (/api/version, publico). Fallback pro APP_VERSION fixo em dev.
  const versaoDeploy = useVersao();
  const navigate = useNavigate();
  const location = useLocation();
  const destino = (location.state as { from?: string } | null)?.from ?? '/';

  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  // Por que caiu aqui (corte diario das 05h, DA-414). Lazy init: le UMA vez e ja limpa, senao
  // um re-render depois do submit ressuscitaria o aviso em cima do erro de senha.
  const [motivo] = useState<string | null>(() => lerMotivoLogin());
  const emergencia = useSemConexao();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await doLogin(login.trim(), senha);
      navigate(destino, { replace: true });
    } catch (err: any) {
      // Device-trust: o backend responde { erro: 'dispositivo_nao_autorizado', mensagem }.
      // Mostra a frase amigavel em vez do codigo.
      const corpo = err?.corpo;
      if (corpo?.erro === 'dispositivo_nao_autorizado' && corpo?.mensagem) {
        setErro(corpo.mensagem);
      } else if (ehFalhaDeRede(err) || estaSemConexao()) {
        setErro(MSG_SEM_SERVIDOR);
      } else {
        setErro(err.message ?? 'falha no login');
      }
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>{APP_NAME}</h1>
        <p className="subtitulo">Entrar no sistema</p>
        {/* Laranja (atencao), nao vermelho: nada falhou — o sistema so encerrou o dia anterior.
            Sai de cena assim que houver erro de verdade pra mostrar. */}
        {motivo && !erro && (
          <p style={{ color: '#f97316', fontSize: 13, lineHeight: 1.4, margin: '0 0 12px' }}>{motivo}</p>
        )}
        {emergencia && !erro && (
          <p style={{ background: '#f97316', color: '#000', fontWeight: 600, fontSize: 13, lineHeight: 1.4, padding: '8px 10px', borderRadius: 6, margin: '0 0 12px' }}>
            {MSG_SEM_SERVIDOR}
          </p>
        )}
        <form onSubmit={onSubmit}>
          <label>
            Usuario
            <input
              type="text"
              autoComplete="username"
              value={login}
              onChange={(e) => setLogin(upperMantendoCursor(e))}
              autoFocus
              required
            />
          </label>
          <label>
            Senha
            <input
              type="password"
              autoComplete="current-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </label>
          {erro && <p className="erro">{erro}</p>}
          <button type="submit" disabled={enviando || !login || !senha}>
            {enviando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p className="versao" title={versaoDeploy ? detalheVersao(versaoDeploy) : undefined}>
          {versaoDeploy ? versaoDeploy.versao : `v${APP_VERSION}`}
        </p>
      </div>
    </div>
  );
}
